import { render, staticRenderFns } from "./Form7StyleOfProceeding.vue?vue&type=template&id=2fbda782&scoped=true"
import script from "./Form7StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form7StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form7StyleOfProceeding.vue?vue&type=style&index=0&id=2fbda782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbda782",
  null
  
)

export default component.exports